import React from 'react';
import { motion } from 'framer-motion';
import { useAuthStore } from '../store/auth';
import DashboardAdmin from './dashboards/DashboardAdmin';
import DashboardClinica from './dashboards/DashboardMedico';
import DashboardPaciente from './dashboards/DashboardPaciente';
import DashboardRepresentante from './dashboards/DashboardRepresentante';
const Dashboard = () => {
    const { user } = useAuthStore() ;
    if (!user)
        return null;
    const renderDashboard = () => {
        switch (user.tipo) {
            case 'admin':
                return <DashboardAdmin />;
            case 'medico':
                return <DashboardClinica />;
            case 'paciente':
                return <DashboardPaciente />;
            case 'representante':
                return <DashboardRepresentante />;
            default:
                return <div>Tipo de usuário não reconhecido</div>;
        }
    };
    return (<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} className="min-h-screen bg-gray-50">
      {renderDashboard()}
    </motion.div>) ;
};
export default Dashboard;
